import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import history from 'dashboard/history';
import moment from 'moment';
import { numeral } from 'lib/helpers';
import CDNManager from 'dashboard/CDN/CDNManager';
import Toolbar from '../Toolbar.react';
import Button from 'components/Button/Button.react';
import stylesButton from 'components/Button/Button.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import BrowserMenu from 'components/BrowserMenu/BrowserMenu.react';
import MenuItem from 'components/BrowserMenu/MenuItem.react';
import Separator from 'components/BrowserMenu/Separator.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import Steps, { Step } from 'components/ProgressSteps/index';

import styles from '../CDN.scss'
import createStyles from './Create.scss'
import settingsStyles from 'dashboard/Settings/Settings.scss';

export default class Create extends Component {
  constructor(props) {
    super();

    this.section = 'CDN';
    this.subsection = 'Create Site';

    this.state = {
      loading: true,
      currentStep: 1,
    };
  }

  componentWillReceiveProps(nextProps) {

  }

  componentDidMount() {
    this.setState({
      loading: false,
    });
  }

  changeSteps() {
    this.setState((state) => {
      let currentStep;
      if(state.currentStep === 4) {
        currentStep = 1;
      } else {
        currentStep = state.currentStep + 1;
      }

      return { currentStep };
    });
  }

  selectHandler(v) {
    this.setState({
      selected: v,
    })
  }

  goBack() {
    if(this.state.currentStep === 1) {
      history.goBack()
    }

    if(this.state.currentStep > 1) {
      this.setState((state) => {
        return {
          currentStep: state.currentStep -1,
        }
      })
    }
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    if(this.state.loading) {
      return (
        <div className={classes.join(' ')}>
          <Toolbar {...this.props} subsection={this.props.route.name}>
            <Button  value='Go Back' onClick={() => history.goBack()} />
          </Toolbar>
          <PreLoader loading={this.state.loading} />
        </div>
      );
    }

    return (
      <div className={classes.join(' ')}>
        {
          <Toolbar {...this.props} subsection={this.props.route.name}>
            <Button  value='Go Back' onClick={() => this.goBack()} />
          </Toolbar>
        }
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={[styles.holder, styles.withTopPadding].join(' ')}>
              <Steps current={this.state.currentStep}>
                <Step title="Choose a Type" />
                <Step title="Choose Application" />
                <Step title="Create CDN" />
              </Steps>

              {
                this.state.currentStep === 1 &&
                  <div>
                    <div className={createStyles.box}>
                      <div className={createStyles.itemWrapper}>
                        <div className={[createStyles.item, this.state.selected === 1 ? createStyles.selected : null].join(' ')} onClick={() => this.selectHandler(1)}>
                          <div>
                            <h2>SashiDo Application</h2>
                            <p>Select your application to use our SashiDo CDN Network.</p>
                          </div>
                        </div>
                      </div>
                      <div className={createStyles.itemWrapper}>
                        <div className={[createStyles.item, this.state.selected === 2 ? createStyles.selected : null].join(' ')} onClick={() => this.selectHandler(2)}>
                          <div>
                            <h2>External Site</h2>
                            <p>Select static site if you only need to serve static content with high availability and high performance</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles.action}>
                      <Button  value='Choose' disabled={!this.state.selected} color='green' onClick={() => this.changeSteps()} />
                    </div>
                  </div>
              }

              {
                this.state.currentStep === 2 &&
                  <div className={styles.action}>
                    <Button  value='Select' color='green' onClick={() => this.changeSteps()} />
                  </div>
              }

            </div>
          </div>
        </PreLoader>
      </div>
    );
  }
}
